import React from 'react'
import classNames from 'classnames'

export const AudioTrackProgress = ({ isDisabled, duration, progress, handleScrub }) => {
  return (
    <input
      data-testid="audio-track-progress"
      type="range"
      className={classNames({ disabled: isDisabled })}
      min={0}
      max={duration}
      value={progress}
      step={0.01}
      onChange={handleScrub}
      disabled={isDisabled}
    />
  )
}
